import { render, staticRenderFns } from "./building.vue?vue&type=template&id=2facf920&scoped=true"
import script from "./building.vue?vue&type=script&lang=ts"
export * from "./building.vue?vue&type=script&lang=ts"
import style0 from "./building.vue?vue&type=style&index=0&id=2facf920&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2facf920",
  null
  
)

export default component.exports